module.exports = __webpack_public_path__ + "img/flamethrower-turret-muzzle-fire.b7de729c.png";